import { render, staticRenderFns } from "./BaseDropDown.vue?vue&type=template&id=2bbc86ae&"
import script from "./BaseDropDown.vue?vue&type=script&lang=js&"
export * from "./BaseDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports